export default __webpack_public_path__ + "static/media/Instagram.eaa67068.svg";